import React, { useEffect } from 'react'

export default function Clients() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (

        <>

            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="breadcrumb-title">
                                    Our <span className="breadcrumb-highlight">Trusted Clients</span>
                                </h1>
                                {/* <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>


            <div className="clients-section">
                <div className="clients-container">
                    <h1 className="clients-title">Our Clients</h1>
                    <div className="title-underline"></div>
                    <p className="clients-description">We are proud to work with a diverse range of clients, from startups to Fortune 500 companies.</p>

                    <div className="clients-grid">
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-1.webp')} alt="Client 1" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-2.png')} alt="Client 2" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-3.png')} alt="Client 3" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-4.png')} alt="Client 4" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-5.png')} alt="Client 5" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-6.png')} alt="Client 6" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-7.png')} alt="Client 7" />
                        </div>
                        <div className="client-card">
                            <img src={require('../assets/images/client/clint-8.png')} alt="Client 8" />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
